import useEditorContext from "../useEditorContext";
import { TEXT_COLORS, TextColor } from "../../tools/TextTool";
import ToolbarColors from "./ToolbarColors";
import TextUtils from "../../utils/TextUtils";

const ToolbarActionText = () => {
  const { instance, setToolOptions, toolOptions } = useEditorContext();

  const isTextAdded = instance?.canvas
    ? Boolean(TextUtils.getTextObjectFromCanvas(instance.canvas))
    : false;

  if (!instance?.canvas) return null;

  const handleColorClick = (fill: TextColor) => {
    const { canvas } = instance;

    if (canvas && isTextAdded) {
      TextUtils.updateTextObjectFill(canvas, fill);
    }

    setToolOptions({ fill });
  };

  const currentColor =
    toolOptions && "fill" in toolOptions && toolOptions.fill
      ? toolOptions.fill
      : null;

  return (
    <div className="h-12">
      <ToolbarColors
        colors={TEXT_COLORS}
        currentColor={currentColor}
        onClick={handleColorClick}
      />
    </div>
  );
};

export default ToolbarActionText;
